import React from 'react';
import { Cardapio } from 'modulos/cardapio/containers';

export const CardapioQrCode = () => {
  return <Cardapio visualizacao="gerarQrCode" />;
};
